import styled from "styled-components";

export const MainContainer = styled.div`
    width: 100%;
    height: 100%;

    .title {
        padding-top: 50px;
        font-family: 'BebasNeue';
        font-size: 28px;
        color: #212529;
        .todayLb {
            font-family: 'S-CORE-DREAM';
            font-size: 13px;
            color: #6c757d;
        }
    }

    .mainDiv {
        padding-top: 40px;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 16px;
    }

    .menuBtn {
        width: 75%;
        max-width: 360px;
        background: #fff;
        border: 1px solid #dee2e6;
        border-radius: 12px;
        display: flex;
        height: 72px;
        justify-content: center;
        align-items: center;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        font-family: 'S-CORE-DREAM';
        text-decoration: none;
        transition: background 0.15s, box-shadow 0.15s, transform 0.1s;

        &:hover {
            background: #f8f9fa;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        &:active {
            transform: scale(0.98);
        }

        span:nth-child(1) {
            color: #212529;
            font-size: 17px;
            font-weight: 600;
            margin-right: 8px;
        }
        span:nth-child(2) {
            font-family: 'BebasNeue';
            font-size: 14px;
            color: #adb5bd;
        }
    }

    .bottomLb1 {
        padding-top: 40px;
        margin: 0;
        font-family: 'S-CORE-DREAM';
        font-size: 16px;
        font-weight: 500;
        color: #495057;
    }

    .bottomLb2 {
        font-weight: 500;
        padding: 0;
        margin: 4px 0 0;
        font-family: 'BebasNeue';
        font-size: 11px;
        letter-spacing: 2px;
        color: #adb5bd;
    }

    .helpBtn {
        position: absolute;
        top: 16px;
        right: 12px;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        background: #fff;
        color: #495057;
        font-size: 18px;
        font-weight: 600;
        font-family: 'Roboto', sans-serif;
        cursor: pointer;
        transition: background 0.15s;
        &:hover { background: #e9ecef; }
    }

    .about {
        position: fixed;
        right: 0;
        bottom: 0;
        margin: 15px;
        font-family: 'BebasNeue';
        font-size: 12px;
        color: #6c757d;
    }
`;
